<template>
  <v-app>
    <Snackbar />
    <template>
      <div class="text-center">
      </div>
    </template>

    <v-app-bar app clipped-left
>
    <v-toolbar-title>
       <v-app-bar-nav-icon v-if='isAuthorized' @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    Genetic Trust Admin Portal
    </v-toolbar-title>

    <v-spacer></v-spacer>
   <v-btn
        v-if='isAuthorized'
        @click='logout'
        icon
      >
        <v-icon>exit_to_app</v-icon>
      </v-btn>
  </v-app-bar>

      <v-navigation-drawer
      style="position:fixed"
      v-model="drawer"
      height='100%'
      v-if='isAuthorized'
      dark
      color='#126297'
      expand-on-hover
      absolute
      clipped
      app
    >
   
      <v-divider></v-divider>

      <v-list>
    <v-list-item class='mb-12'>
     <v-list-item-action></v-list-item-action>
    </v-list-item>
  </v-list>

      <v-list
        nav
        dense
        flat
      >
      <template v-for="(item,keys) in items">
  <v-list-item
    v-bind:key='keys'
    link
    :to='item.route'
  >
    <v-list-item-icon>
      <v-icon size='30'>{{item.icon}}</v-icon>
    </v-list-item-icon>
    <v-list-item-title>{{item.text}}</v-list-item-title>
  </v-list-item>
  </template>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar'
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'App',
  components: {
    Snackbar
  },
  mounted () {
    if(this.$router.currentRoute.fullPath !== "/"){
      this.inactivityTime()
    }
    
  },
  data () {
    return {
      drawer: null,
      mini: true,
      items: [
        { text: "Home", route: "/home", icon: "home" },
        { text: "Users Assigned to me", route: "/tasks", icon: "edit" },
        { text: "My Notification History", route: "/history", icon: "history" },
        { text: "All users", route: "/patients", icon: "wc" },
        { text: "Group Notifications", route: "/groupNotifications", icon: "apps" },
        { icon: "person", text: "My Account", route: "/account" },
        { icon: "group", text: "Users Management", route: "/users" },
        { icon: "mail", text: "Email Editor", route: "/emailEditor"},
         { icon: "settings", text: "Settings", route: "/settings"}

      ]
    }
  },
  computed: {
    ...mapFields([
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
  },
  methods: {
    inactivityTime () {
      var time;
      window.onload = resetTimer;
      // DOM Events
      document.onmousemove = resetTimer;
      document.onkeypress = resetTimer;

      function logout () {
        alert("Session timed out")
        location.href = '/'
      }
      function resetTimer () {
        clearTimeout(time);
        time = setTimeout(logout, 900000)
        // 1000 milliseconds = 1 second
      }
    },
    logout () {
      window.location.reload()
    },
    routeTo (item) {
      this.$router.push(item.route);
    },
  }

}
</script>
